var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isMobileApp)?_c('v-icon',[_vm._v(_vm._s(_vm.IconConstants.Cellphone))]):_vm._e(),_c('v-icon',[_vm._v(_vm._s(_vm.appOsIcon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }